// 设置路由
import Layout from '@/view/layout' // 主框架

export default {
  path: '/setting',
  component: Layout,
  children: [
    {
      path: 'workwechat',
      component: () => import('@/view/setting/workwechat'),
      name: '企业微信设置'
    },
    {
      path: 'generalSettings',
      component: () => import('@/view/setting/generalSettings'),
      name: '通用设置'
    },
    {
      path: 'openScreenAd',
      component: () => import('@/view/setting/openScreenAd'),
      name: '开屏广告设置'
    },
    {
      path: 'weappTmp',
      component: () => import('@/view/weappTmp/index'),
      name: '微信模版装修'
    },
    {
      path: 'actionWeappTmp',
      component: () => import('@/view/formActivity/editorTool.vue'),
      name: '活动详情配置'
    },
    {
      path: 'formWeappTmp',
      component: () => import('@/view/formActivity/editorFormTool.vue'),
      name: '表单模版配置'
    },
    {
      path: 'guideShopshelf',
      component: () => import('@/view/setting/guideShopshelf'),
      name: '导购货架装修'
    },
    {
      path: 'role',
      component: () => import('@/view/setting/roleSetting'),
      name: '角色权限'
    },
    {
      path: 'platformstaff',
      component: () => import('@/view/setting/platformstaffSetting'),
      name: '管理员'
    },
    {
      path: 'devSettings',
      component: () => import('@/view/setting/devSettings'),
      name: '开发设置'
    },
    {
      path: 'account',
      component: () => import('@/view/setting/account'),
      name: '账号信息'
    },
    {
      path: 'datamessage',
      component: () => import('@/view/setting/datamessage'),
      name: '短信信息'
    },
    {
      path: 'demo',
      component: () => import('@/view/demo/index'),
      name: 'demo'
    },
    {
      path: 'notice',
      component: () => import('@/view/home/notice')
    }
  ]
}
